//Created by wangshuyi on 07/03/2018.

'use strict';
import axios from 'axios';
import * as querystring from 'querystring';
import moment from 'moment';

const defaultConfig = {
  method: 'post',
  showMessage: true,
  loadingTimeout: true,
};

const langMap = {
  'zh': 10141001,
  'en': 10141002,
  'ru': 10141003,
};

function getErrorMessageByRow(e){
  const msg = [];
  e.data.ERROR_INFO.forEach(row => {
    msg.push(`${this.$t(row.ERROR_CODE) || row.ERROR_MESSAGE}【${row.ERROR_DATA}】`);
  })

  return msg.join('\n')
}

function erp(params) {
  let param = Object.assign({}, defaultConfig, params);
  param.url = this.$Dolphin.path.erpPath + param.url;

  if (param.pathData) {
    for (let key in param.pathData) {
      param.url = param.url.replace(`{${key}}`, param.pathData[key]);
    }
  }

  let showLoadingTimeout;
  if (param.loading && this.$store && typeof this.$store.state.loading === 'boolean') {
    if (params.loadingTimeout) {
      showLoadingTimeout = setTimeout(() => {
        this.$store.commit('setLoading', true);
      }, 500);
    } else {
      this.$store.commit('setLoading', true);
    }
  }
  return axios(Object.assign({
    transformRequest: [(data) => {
      return querystring.stringify({ postData: JSON.stringify(data) });
    },],
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  }, param)).then((reData) => {
    let data = reData.data;
    if (typeof data === 'string') {
      try {
        if (data && Object.prototype.toString.call(data) == "[object String]" && data != 'null') {
          data = data.replace(/\r/g, "\\r");
          data = data.replace(/\n/g, "");
          data = data.replace(/\t/g, "\\t");
          data = data.replace(/\\/g, "\\\\");
          /*data = data.replace(/\'/g, "&#39;");
          data = data.replace(/ /g, "&nbsp;");
          data = data.replace(/</g, "$lt;");
          data = data.replace(/>/g, "$gt;");*/
        }
        data = JSON.parse(data);
      } catch (e) {
        console.error('返回数据转换JSON失败');
      }
    }
    if (data.status && data.status !== "0") {
      throw data;
    }
    return data;
  }).catch(e => {
    if (param.showMessage) {
      let errorMessage;
      switch (e.status){
        case '3001': errorMessage = e.message; break;
        case '3004': errorMessage = getErrorMessageByRow.call(this, e); break;
        default: errorMessage = this.$t(e.status) || e.message;
      }
      if (window.$DolAntPage) {
        window.$DolAntPage.$error({title: this.$t('sysMessage'), content: errorMessage})
      } else if (window.$DolVantPage) {
        window.$DolVantPage.$dialog.alert({ title: this.$t('sysMessage'), content: errorMessage });
      } else {
        alert(errorMessage);
      }
    }

    // 特殊处理，如果错误码是3006，说明企业已禁用，直接自动登出 TODO 不兼容游客和注册过程界面，
    // if (window.$DolAntPage) {
    //   window.$DolAntPage.$store.dispatch('logout').then(() => {
    //     window.$DolAntPage.$router.replace('/login');
    //   });
    // } else if (window.$DolVantPage) {
    //   window.$DolVantPage.$store.dispatch('logout').then(() => {
    //     window.$DolVantPage.$router.replace('/login');
    //   });
    // } else {
    //   location.href = '/login'
    // }

    throw e;
  }).finally(() => {
    if (param.loading && this.$store && typeof this.$store.state.loading === 'boolean') {
      if (showLoadingTimeout) {
        clearTimeout(showLoadingTimeout);
      }
      this.$store.commit('setLoading', false);
    }
  });
}

function h5Api({ type, data, showMessage = true, loading = true } = {}) {
  const token = this.$store ? this.$store.state.token : '';

  let commonParams = {
    "SERVICE_TYPE": type,
    "USER_ID": token || this.$constant.DEFAULT_USER_ID,
    "H5_CREATE_DATE": moment().format('YYYY-MM-DD HH:mm:ss'),
    "INPUT_PARAM": data,
    "LANG_TYPE": langMap[localStorage.getItem('lang')]
  };

  return erp.call(this, {
    url: `/H5CallAPI?f=${type}`,
    method: 'post',
    data: commonParams,
    showMessage: showMessage,
    loading: loading,
  });
}

export { erp, h5Api };
